<template>
  <el-select :value="value" placeholder="Select State" filterable :loading="loading" no-match-text=" " @input="updateState">
    <el-option v-for="item in allUSStates" :key="item.id" :label="item.name" :value="item.id"></el-option>
  </el-select>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  props: {
    value: String,
  },
  data() {
    return {
      loading: true,
    };
  },
  computed: {
    ...mapGetters('Lookup', ['allUSStates']),
  },
  methods: {
    ...mapActions('Lookup', ['getUSStates']),
    updateState(val) {
      this.$emit('input', val);
    },
  },
  mounted() {
    this.getUSStates().then(() => {
      this.loading = false;
    });
  },
};

</script>
